// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--lTqd_","crumb":"_7a3fb80146--crumb--N_28L","arrow":"_7a3fb80146--arrow--f6SOK"};